import GetHotelClassificationBusinessesRequestModelBase from '../_generated/modelBases/get-hotel-classification-businesses-request-model-base';

export default class GetHotelClassificationBusinessesRequestModel extends GetHotelClassificationBusinessesRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
